
export default {
  props: {
    following: {type: Boolean, default: false},
  },
}
